/**
 * @generated SignedSource<<9e6e0435e948129fcdb5920c201bd9c0>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type selectedView_issueNavigator_SelectedViewContainer_jiraView$data = {
  readonly viewId?: string | null | undefined;
  readonly " $fragmentType": "selectedView_issueNavigator_SelectedViewContainer_jiraView";
};
export type selectedView_issueNavigator_SelectedViewContainer_jiraView$key = {
  readonly " $data"?: selectedView_issueNavigator_SelectedViewContainer_jiraView$data;
  readonly " $fragmentSpreads": FragmentRefs<"selectedView_issueNavigator_SelectedViewContainer_jiraView">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "selectedView_issueNavigator_SelectedViewContainer_jiraView",
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "viewId"
        }
      ],
      "type": "JiraIssueSearchViewMetadata",
      "abstractKey": "__isJiraIssueSearchViewMetadata"
    }
  ],
  "type": "JiraView",
  "abstractKey": "__isJiraView"
};

(node as any).hash = "cf266a14f94b711c625c539ed89becfa";

export default node;
